import React from "react";
import EditProfile from "./views/EditProfile";
import { EditProfileContextProvider } from "./EditProfileView";

const EditProfilePage = () => {
  return (
    <div>
      <EditProfileContextProvider>
        <EditProfile />
      </EditProfileContextProvider>
    </div>
  );
};
export default EditProfilePage;
